import { en as importDialog } from "./import-export/index";

export const en = {
  ...importDialog,
  cartDetails: {
    id: 'Code',
    proceedToCheckout: 'Proceed to payment',
    cartName: 'Cart #{{code}}',
  },
  cartItems: {
    id: 'Code',
    description: 'Description',
    item: 'Item',
    itemPrice: 'Item price',
    price: 'Price',
    offer: 'Offer',
    newPrice: 'New Price €/TM (Discount)',
    totalPrice: 'Total price',
    unit: 'Unit',
    width: 'Width',
    numberOfSheets: 'Qty. of packages',
    quantityPaquete: 'Sheets / Package',
    quantityTubos: 'Tubs on package',
    weight: 'Weight per package',
    totalWeight: 'Total weight',
    quantityTitle:
      'The quantity represents the total number of this item in your cart.',
    total: 'Total',
    actions: 'Actions',
    cartTotal: 'Cart total ({{count}} item)',
    cartTotal_other: 'Cart total ({{count}} items)',
    itemRemoved: 'The selected item has been removed. The cart total has been updated.',
    caption: 'Shopping cart contents.',
    orderExpress: {
      title: 'Order Express',
      important: 'Take advantage of a faster purchasing process:',
      topic1: 'If you have more than one delivery address, go to My Company / Addresses and set the Default Address.',
      topic2: 'If you only have one address, the previous step is not necessary. The shipping method will be express.',
      topic3: 'You just need to enter the order number below, indicate that you want this option, and confirm your order details at Checkout.',
      agree: 'Validate to Proceed with Express Purchase',
      checkout: 'Checkout',
      orderNumber: 'Order number'
    },
    lowNumberOfSheets: 'It is not possible to purchase this quantity, the bundle weight is below the minimum allowed of {{weight}} kg',
    packageWeightExceeded: 'It is not possible to purchase this quantity, the bundle weight exceeds the maximum allowed of {{weight}} kg'
  },
  orderCost: {
    orderSummary: 'Order summary',
    totalWeight: 'Total Weight:',
    subtotal: 'Subtotal after discounts:',
    shipping: 'Shipping:',
    estimatedShipping: 'Estimated shipping:',
    discount: 'Discounts of the order:',
    salesTax: 'Sales tax:',
    grossTax: 'The order total does not include taxes from',
    grossIncludeTax: 'The order total includes taxes from',
    value: 'Value:',
    total: 'Total Value:',
    toBeDetermined: 'TBD',
    taxWarn: 'Tax not included',
  },
  voucher: {
    coupon: 'Do you have a coupon?',
    coupon_other: 'Coupon codes',
    couponLabel: 'Enter a promo code here',
    apply: 'Apply',
    placeholder: 'Promo code',
    applyVoucherSuccess: '{{voucherCode}} has been applied.',
    removeVoucherSuccess: '{{voucherCode}} has been removed.',
    anchorLabel: 'Enter or remove your coupon code',
    vouchersApplied: 'Applied coupons',
    availableCoupons: 'Available coupons',
    availableCouponsLabel: 'You can add these coupons to this order.',
  },
  saveForLaterItems: {
    itemTotal: 'Saved for later ({{count}} item)',
    itemTotal_other: 'Saved for later ({{count}} items)',
    cartTitle: 'Cart',
    saveForLater: 'Save for later',
    moveToCart: 'Move to cart',
    stock: 'Stock',
    forceInStock: 'In stock',
  },
  clearCart: {
    clearCart: 'Clear cart',
    clearingCart: 'Clearing cart...',
    cartClearedSuccessfully: 'The active cart has been successfully cleared.',
    areYouSureToClearCart: 'Are you sure you want to clear this cart?',
    allItemsWillBeRemoved: 'All items in your active cart will be removed.',
  },
  validation: {
    cartEntriesChangeDuringCheckout:
      'During the checkout process, we encountered issues with your items. Please review your cart.',
    cartEntryRemoved:
      '{{name}} was removed from the cart because it is out of stock.',
    productOutOfStock:
      '{{name}} was removed from the cart because there is not enough stock.',
    lowStock: 'The quantity has been reduced to {{quantity}} due to lack of stock.',
    reviewConfiguration:
      'Please resolve the issues in the configuration for the cart item first.',
    configurationError:
      'Please resolve the issues in the configuration of the cart items first.',
    pricingError:
      'Pricing configuration is currently unavailable. It is not possible to complete the purchase or submit a quotation. Please try again later.',
    unresolvableIssues:
      'The product configuration requires additional inputs on the back-end. As a result, you cannot proceed. Please contact support.',
    inProgress: 'In progress',
  },
};

export const savedCartList = {
  savedCarts: 'Saved Carts ({{count}})',
  cartName: 'Name',
  weight: 'Total Weight (KG)',
  cartId: 'Identification',
  description: 'Description',
  dateSaved: 'Save Date',
  cartDescription: 'Description',
  quantity: 'Quantity',
  total: 'Total',
  actions: 'Actions',
  makeCartActive: 'Activate Cart',
  notFound: 'No saved cart found',
  swapCartNoActiveCart:
    'The existing cart was successfully activated by {{{cartName}}.',
  swapCartWithActiveCart:
    'The existing cart was successfully activated by {{{{cartName}}. Your previous items were saved in a cart {{{{previousCartName}}.',
};

